<template>
    <base-draggable-modal
        name="documentation"
        max-height="80vh"
        width="70vw"
        :fullscreen="$vuetify.display.xsOnly"
        ref="documentation">
      <v-card rounded="xl">
        <base-modal>
          <template #header>
            <v-toolbar class="draggable_selector" flat color="secondary" density="compact">
              <v-toolbar-title class="text-primary">{{ $store.getters.translate(page.name) }}</v-toolbar-title>
            </v-toolbar>
          </template>
          <template #content>
              <v-card-text>
                <v-row v-if="loaded_page">
                  <v-col>
                    <p style="font-size: 24px; font-weight: 600;">{{ loaded_page.name }}</p>
                    <div v-html="loaded_page.html"/>
                  </v-col>
                </v-row>
              </v-card-text>
          </template>
          <template #footer>
            <v-card-text>
              <v-row>
                <v-col class="text-center">
                  <base-action-button :width="'50%'" @action="closeModal('documentation')">
                    <template #prepend><PhX style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                    {{ $store.getters.translate("cancel") }}
                  </base-action-button>
                </v-col>
              </v-row>
            </v-card-text>
          </template>
        </base-modal>
      </v-card>
    </base-draggable-modal>
</template>

<script>
import helpFunctions from "../../plugins/helpFunctions";
import BaseModal from "./BaseModal";
import BaseDraggableModal from "./BaseDraggableModal";
import BaseActionButton from "./BaseActionButton";
import {PhX} from "@phosphor-icons/vue";

export default {
  components: {
    BaseActionButton,
    BaseModal,
    BaseDraggableModal,
    PhX,
  },
  props: ["selected_chapter", "selected_page"],
  data() {
    return {
      page: helpFunctions.pages.documentation,
      loaded_page: null,
    };
  },
  methods: {
    ...helpFunctions.modal_functions,
    async load() {
      this.openModal('documentation');
      if(this.selected_chapter && this.selected_chapter.type === 'page') {
        await this.getPage(this.selected_chapter);
      }
      else if(this.selected_page) {
        await this.getPage(this.selected_page);
      }
    },
    async getPage(page) {
      this.loaded_page = await helpFunctions.postCustomRoute(this.$toast, this.page.name + "/get-page", { page: page.id }, false, true);
    },
  }
};
</script>